/**
 * Ecosystem health is recorded as free text, but the app offers a fixed set of
 * levels. Older records use variants ("Good", "Fair"), so lookups normalise.
 */
/*
 * `color` is the semantic status colour used by the HealthChip (always beside
 * a text label). `rampColor` is a validated single-hue ordinal ramp, light to
 * dark, used when the levels sit next to each other in a chart.
 */
export const HEALTH_LEVELS = [
  {
    key: 'healthy',
    label: 'Healthy',
    matches: ['healthy', 'good', 'excellent'],
    color: '#2e7d32',
    rampColor: '#76b783',
    rank: 4,
  },
  {
    key: 'moderate',
    label: 'Moderately Healthy',
    matches: ['moderately healthy', 'moderate', 'fair'],
    color: '#f9a825',
    rampColor: '#4a9358',
    rank: 3,
  },
  {
    key: 'stressed',
    label: 'Stressed',
    matches: ['stressed', 'poor'],
    color: '#ef6c00',
    rampColor: '#2b6a3a',
    rank: 2,
  },
  {
    key: 'degraded',
    label: 'Severely Degraded',
    matches: ['severely degraded', 'degraded', 'critical'],
    color: '#c62828',
    rampColor: '#163F30',
    rank: 1,
  },
];

export const UNKNOWN_HEALTH = { key: 'unknown', label: 'Not assessed', color: '#90a4ae', rampColor: '#b0bec5', rank: 0 };

export const healthLevel = (value) => {
  const needle = String(value || '').trim().toLowerCase();
  if (!needle) return UNKNOWN_HEALTH;
  return HEALTH_LEVELS.find((level) => level.matches.includes(needle)) || { ...UNKNOWN_HEALTH, label: value };
};

export const HEALTH_OPTIONS = HEALTH_LEVELS.map((level) => ({ value: level.label, label: level.label }));
